import { searchListSlice } from './list_slice';
import {
  clearActiveSearchViewId,
  setActiveSearchViewId,
  setSearchDisplayFields,
} from './slice';

/**
 * The search page drives both the shared list state for its results and its own
 * view state, so this bundles the actions of both slices under one object.
 */
export const searchActions = {
  ...searchListSlice.actions,
  setActiveSearchViewId,
  clearActiveSearchViewId,
  setSearchDisplayFields,
};

export const setSearchSorting = searchActions.setSort;
